if (!customElements.get("custom-video")) {
  class customVideo extends HTMLElement {
    constructor() {
      super();
      this.videoWrapper = this.querySelector('.td-video-wrapper');
      this.video = this.querySelector('video');
      this.playbutton = this.querySelector('.video-play-button');
      this.playing = false;

      // Initialize Intersection Observer
      this.intersectionObserver = new IntersectionObserver(entries => this.handleIntersection(entries), {
        root: null,
        rootMargin: '0px',
        threshold: 0
      });
    }

    static currentlyPlayingVideo = null;

    connectedCallback() {
      if (this.video && this.playbutton && this.videoWrapper) {
        if (!this.videoWrapper.hasEventListener) {
          this.videoWrapper.addEventListener('click', () => this.handleVideoClick());
          this.videoWrapper.hasEventListener = true;
        }

        // Listen for the custom event emitted from swiper-slider.js
        document.addEventListener('swiperSlideChanged', () => {
          if (this.playing) {
            this.playbutton.style.display = "block";
            this.pauseVideo();
          }
        });
        this.intersectionObserver.observe(this.videoWrapper);
      }
    }

    handleVideoClick() {
      console.log("click")
      if (customVideo.currentlyPlayingVideo && customVideo.currentlyPlayingVideo !== this) {
        
        customVideo.currentlyPlayingVideo.pauseVideo();
      }

      if (this.playing) {
        this.playbutton.style.display = "block";
        this.pauseVideo();
      } else {
        this.playbutton.style.display = "none";
        this.playVideo();
      }
    }

    playVideo() {
      this.video.play().catch(e => console.error('Error attempting to play video:', e));
      this.playing = true;
      customVideo.currentlyPlayingVideo = this;
    }

    pauseVideo() {
      this.video.pause();
      this.playing = false;
      customVideo.currentlyPlayingVideo = null;
    }

    handleIntersection(entries) {
      entries.forEach(entry => {
        if (entry.intersectionRatio <= 0) {
          this.playbutton.style.display = "block";
          this.pauseVideo();
        }
      });
    }
  }

  customElements.define("custom-video", customVideo);
}
